"use client";
import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import CustomInput from "@/components/shared/CustomInput";
import Image from "next/image";
import searchIcon from "@/public/images/search.svg";
import { Separator } from "@/components/ui/separator";
import Pagination from "@/components/shared/Pagination";
import Header from "@/components/shared/Header";
import Footer from "@/components/shared/Footer";
import instructorImage from "@/public/images/instructorImage.svg";

import BookCard from "@/components/shared/BookCard";
import { useAppDispatch, useAppSelector } from "@/redux/store";
import USER, { SelectBooks } from "@/redux/User";
import GENERAL, { SelectSchoolYears } from "@/redux/GENERAL";
import SocialMedia from "@/components/shared/socialMedia/SocialMedia";
// import { Metadata } from "next";

// export const metadata: Metadata = {
//   title: "الكتب",
// };
const Page = () => {
  const dispatch = useAppDispatch();
  const [page, setpage] = useState(1);
  const [search, setsearch] = useState("");
  const books = useAppSelector(SelectBooks);
  const [schoolYearSelected, setschoolYearSelected] = useState<any>([]);
  const [searchValue, setsearchValue] = useState("");

  const schoolYear = useAppSelector(SelectSchoolYears);

  useEffect(() => {
    dispatch(GENERAL.thunks.doGetSchoolYears({}));
  }, []);

  useEffect(() => {
    dispatch(
      USER.thunks.doGetBooks({
        search: searchValue,
        subject_id: "",
        school_years: schoolYearSelected,
        education_types: [],
        teacher_name: "",
      })
    );
  }, [searchValue, schoolYearSelected]);

  return (
    <div>
      <Header />

      <div className="container my-10 flex flex-col gap-10">
        <div className="bg-[#323538] rounded-[20px] p-3 flex flex-col gap-5">
          <div className="flex items-center bg-[#474A4D] rounded-[5px] py-2 pl-3">
            <Formik
              initialValues={{ search: "" }}
              onSubmit={(values) => {
                setsearchValue(values.search);
              }}
            >
              {(props) => (
                <Form className="w-full flex justify-between gap-4">
                  <CustomInput
                    type="text"
                    name="search"
                    placeholder="بحث عن كتاب في المنصة"
                    fullWidth={true}
                  />
                  <button type="submit">
                    <Image src={searchIcon} alt="search" />
                  </button>
                </Form>
              )}
            </Formik>
          </div>
          <div className="flex gap-5 flex-wrap">
            {schoolYear.map((year: any, index: number) => (
              <button
                key={index}
                onClick={(e) => {
                  schoolYearSelected.includes(year.id)
                    ? setschoolYearSelected((prev: any) =>
                        prev.filter((item: any) => item !== year.id)
                      )
                    : setschoolYearSelected((prev: any) => [...prev, year.id]);
                }}
                className={`${
                  schoolYearSelected.includes(year.id)
                    ? "bg-primaryColor text-black"
                    : "bg-[#474A4D] text-white"
                } rounded-[5px] text-14 w-fit py-3 px-5`}
              >
                {year.name}
              </button>
            ))}
          </div>
        </div>

        {books.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 place-content-center place-items-center">
            {books.map((item: any, index: number) => (
              <BookCard
                key={index}
                id={item?.id}
                image={item?.image}
                years={item?.school_years}
                teacherName={item?.teacher_name}
                teacherImage={item?.teacher_image || instructorImage}
                subject={item?.subject?.name}
                price={item?.price}
                name={item?.name}
                description={item?.description}
                examNumber={item?.quantity}
                starNumber={item?.stars}
                fileNumber={item?.pages}
              />
            ))}
          </div>
        ) : (
          <div className="text-center text-red-400 bg-[#474A4D] rounded-[5px] py-5 px-3">
            لم يتم العثور على بيانات بناءً على الفلاتر الخاصة بك
          </div>
        )}

        {/* <Pagination page={page} setpage={setpage} numberOfPages={10} /> */}
      </div>
      <SocialMedia />
      <Footer />
    </div>
  );
};

export default Page;
